<template>
    <div id="payment" class="payment-summary-component">
        <password-input-component class="d-none" id="custom-input-password-origin"></password-input-component>
        <form>
        <input type="hidden" name="_token" :value="$csrf">
        <h5 class="blue_title">Summary</h5>
        <div class="mt-4">
            <div class="col-lg-12">
                <p v-if="this.pay_formatted > 0">Subtotal in RM <span class="blue_h5" id="subtotalSummary">RM {{ this.pay_formatted }}</span></p>
                <p>Subtotal in BPoints <span class="blue_h5" id="subtotalBpointSummary">{{ this.point_formatted }} BPoints</span></p>
                <p v-if="discounts_bpoint > 0">Discounts in BPoints <span class="blue_h5" id="">- {{ this.discounts_bpoint_formatted }} BPoints</span></p>
                <p class="minimum-warning" v-if="overflow_bpoint"><span class="title">Sorry, total transaction value cannot be less than 100 Bpoints.</span></p>
                <!-- <p v-if="discounts_price > 0">Discounts in RM <span class="blue_h5" id="">RM {{ this.discounts_price_formatted }}</span></p> -->
            </div>
        </div>
        <div class="mx-0 mt-3 line2"></div>
        <div class="mt-4">
            <div class="col-lg-12">
                <p>Total
                <span class="blue_h5 blue_h5_bold"><div v-if="this.pay > 0">RM<label id="subtotal" name="subtotal">{{ this.discounted_pay_formatted }}</label>+<br></div>
                <label id="subtotalBpoint"  name="subtotalBpoint">{{ this.discounted_point_formatted }}</label> BPoints</span>

                </p>
<!-- <input type="text" id="point" name="point" v-model="point"> -->

                <input type="hidden" id="payment_card_no" name="payment_card_no" ref="paymentCardNoInput" >
                <input type="hidden" id="payment_point" name="payment_point" ref="paymentPointInput" value="0">
                <input type="hidden" id="point" name="point" ref="pointInput" >
                <input type="hidden" id="pay" name="pay" ref="payInput" value="0">
                 <input type="hidden" id="payment_method" name="payment_method" ref="paymentMethod" value="payWithBPoint">
            </div>
            <p class="bonus-rewards" v-if="rewards > 0"><span class="bonus-title">Bonus rewards</span> <span class="blue_h5" id="">+ {{ this.rewards_formatted }} BPoints</span></p>
        </div>

        <div class="mt-4">
            <div class="col-lg-12">
                <p class="tiny_p">PROMOTIONAL CODE(S)</p>
                <table v-if="uniqueCodeApplied.length > 0" class="chosen-codes">
                    <thead>
                        <tr><th><b>Applied Promo Codes</b></th></tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in uniqueCodeApplied">
                        <td>{{ item }}</td>
                    </tr>
                    </tbody>
                </table>
                <input v-else class="codes" type="text" v-model="mainPromoCode" @keypress.enter="openPromoModal()">
                <div class="btn_blue mt-3" style="width: 120px;" @click="openPromoModal()">Add a Promo</div>
            </div>
        </div>

        <div id="promo_code_modal" class="modal fade alert-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">

                <div class="modal-content container">
                    <div class="discount-modal-header">Discount code</div>
                    <div class="discount-body discount-wrapper">
                        <div class="discount-subheader">
                            Bonus discount
                        </div>
                        <hr>

                        <div class="discount-table">
                            <div class="container-fluid">

                                <div class="promo-item-row row-no-padding" v-for="(promoItem, index) in promoItems">
                                    <div class="col-md-5" style="padding-right: 15px;">
                                        {{ promoItem.title }}
                                        <br>
                                        <small>Qty: {{ promoItem.qty }}</small>
                                    </div>
                                    <div class="col-md-7">

                                        <div class="display-table promo-code-table">
                                            <div v-for="promoCode in promoItem.activePromoCodes" class="display-table-row">

                                            <div class="display-table-cell promo-code-cell">
                                                <div class="custom-control custom-checkbox mr-sm-2">
                                                    <input type="checkbox" class="custom-control-input" :id="promoItem.id + '_' + promoCode.id" :value="{promoItem, promoCode}" v-model="selectedPromoCodes" :disabled="checkDisabledPromo(promoCode)">
                                                    <label class="custom-control-label" :for="promoItem.id + '_' + promoCode.id">
                                                        <span class="promo-description">{{ promoCode.code }}</span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div class="display-table-cell">
                                                <span class="promo-description" :class="{ disabled: checkDisabledPromo(promoCode) }">
                                                    {{ promoCode.description }}

                                                    <span class="promo-requirements" v-if="promoCode.minimum_requirements">
                                                        ({{ promoCode.minimum_requirements }})
                                                    </span>
                                                </span>
                                            </div>

                                            </div>

                                            <div class="display-table-row" v-if="promoItem.activePromoCodes.length > 0">
                                                <div class="display-table-cell promo-code-cell">
                                                </div>
                                                <div class="display-table-cell">
                                                    <span class="or-text">OR</span>
                                                </div>
                                            </div>
                                        </div>
                                        <span class="gift-cards-title">Search for Hidden Promotional Codes:</span>
                                        <input class="code-input" type="text" v-model="promoCodeSearchbox[index]" @keypress.enter="searchHiddenCodeForItemIndex(index)"><button class="code-button" type="button" @click="searchHiddenCodeForItemIndex(index)"><i class="fas fa-search-dollar" style="font-size: 13px" aria-hidden="true"></i></button>
                                        <p class="promo-search-status" :class="promoCodeSearchClass[index]">{{ promoCodeSearchText[index] }}</p>
                                        <!--
                                        <div class="input-group">
                                          <input type="text" class="form-control code-input" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="basic-addon2">
                                          <div class="input-group-append">
                                            <button class="btn btn-outline-secondary" type="button">Button</button>
                                          </div>
                                        </div> -->

                                    </div>
                                    <hr v-if="index + 1 < promoItems.length" class="small">
                                </div>
                                <div style="height: 30px;"></div>

                            </div>
                        </div>
                    </div>
                    <!-- S -->
                    <div class="discount-modal-footer">
                        <a @click="" href="javascript:void(0);" class="text-center btn apply-btn" @click="applyPromoCodes()">Apply</a>
                        <a @click="" href="javascript:void(0);" class="text-center btn cancel-btn" data-dismiss="modal" aria-label="Close">Cancel</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-4 mb-5">
            <div class="col-lg-12">
                <!--<div class="btn btn-pink d-inline-flex btn_submit">Dummy GET VALUE</div>-->
                <div class="cart-btn-wrapper v2">
                    <a href="/payment/payment_payment_detail#detail" class="btn btnpink">Back</a>
                    <div class="btn btnpink" @click="cardPin()">CONFIRM AND PAY</div>
                </div>
            </div>
        </div>
        </form>
    </div>

</template>
<script>
    import * as _ from 'lodash';
export default {

    props: ["dataCartSubtotal", "dataCartSubtotalbpoint", "dataPromoItems"],
    data() {
      return {
        url: this.$routes["payment_complete"],
        inputTitle: this.dataInputTitle,
        point: parseInt(this.dataCartSubtotalbpoint.replace(",","")),
        pay: parseFloat(this.dataCartSubtotal.replace(",","")),
        point_formatted: this.dataCartSubtotalbpoint,
        pay_formatted: this.dataCartSubtotal,
        discounted_point_formatted: this.dataCartSubtotalbpoint,
        discounted_pay_formatted: this.dataCartSubtotal,
        cardNo:"",
        pin: "",
        selectedPromoCodes: [],
        selectedPromoCodesApplied: [],
        discounts_bpoint: 0,
        discounts_price: 0,
        rewards: 0,
        discounts_bpoint_formatted: '',
        discounts_price_formatted: '',
        rewards_formatted: '',
        overflow_bpoint: false,
        overflow_price: false,
        promoCodeSearchbox: {},
        promoCodeSearchText: {},
        promoCodeSearchClass: {},
        promoItems: [],
        mainPromoCode: '',
        payment_method:'payWithBPoint',
        paymentPoint:0
      };
    },
    computed: {
        uniqueCodeApplied: function() {
            return _.uniq(_.map(this.selectedPromoCodesApplied, (item) => {
                return item.promoCode.code;
            }));
        }
    },
    mounted: function() {
        this.promoItems = JSON.parse(this.dataPromoItems);
        $('#totalBpointRequire').val(this.discounted_point_formatted.replace(",",""))
    },
    methods: {
        checkDisabledPromo: function(promoCode) {
            var hasMinimumBpoint = promoCode.minimum_bpoint != undefined;
            var hasMinimumPrice = promoCode.minimum_price != undefined;

            if (hasMinimumBpoint && promoCode.minimum_bpoint <= this.point) {
                return false;
            }

            if (hasMinimumPrice && promoCode.minimum_price <= this.pay) {
                return false;
            }

            if (!hasMinimumPrice && !hasMinimumBpoint) {
                return false;
            }

            return true;
        },
        openPromoModal: function() {
            // Check for typed promo code first
            if (this.mainPromoCode != '' && this.uniqueCodeApplied.length < 1) {
                var found = false;
                _.each(this.promoItems, (promoItem) => {
                    var promoCode = _.find(promoItem.activePromoCodes, { 'code': this.mainPromoCode });
                    if (promoCode) {
                        this.selectPromoCode(promoCode, promoItem);
                        found = true;
                    }
                });

                if (found) {
                    Swal.fire({
                        title: 'Success',
                        type: 'success',
                        text: 'You have found a promo code!',
                        allowOutsideClick: () => !Swal.isLoading()
                    });
                    this.mainPromoCode = '';
                } else {
                    this.searchHiddenCodeForAllItems(this.mainPromoCode);
                }
            }
            $('#promo_code_modal').modal('show');
        },
        // Searches hidden promo for ALL items in cart
        searchHiddenCodeForAllItems: async function(code) {
            var items = _.map(this.promoItems, (item) => {
                return {
                    id: item.id,
                    type: item.type,
                };
            });

            const response = await this.$asyncPost(this.$routes["search_promo_codes_multiple"], {
                items, code
            });

            if (response.status == 'success') {
                var found = false;
                var items = response.data;

                // From response see if we have any, if have we push that hidden
                _.each(items, (promoCode, itemId) => {
                    if (promoCode != null) {
                        var promoItem = _.find(this.promoItems, {id: parseInt(itemId)});
                        if (promoItem) {
                            promoItem.activePromoCodes.push(promoCode);
                            this.selectPromoCode(promoCode, promoItem);
                            found = true;
                        }
                    }
                });

                if (found) {
                    Swal.fire({
                        title: 'Success',
                        type: 'success',
                        text: 'You have found a promo code!',
                        allowOutsideClick: () => !Swal.isLoading()
                    });
                    this.mainPromoCode = '';
                }
            }
        },
        setSearchStatus: function(index, status, message) {
            this.$set(this.promoCodeSearchClass, index, status);
            this.$set(this.promoCodeSearchText, index, message);
        },
        // Searches hidden promo for specific item
        searchHiddenCodeForItemIndex: async function(index) {
            this.setSearchStatus(index, 'loading', 'Searching...');
            var code = this.promoCodeSearchbox[index];
            var id = this.promoItems[index].id;
            var type = this.promoItems[index].type;

            // Find existing promo code
            var currentPromoCodes = this.promoItems[index].activePromoCodes;
            var existing = _.find(currentPromoCodes, ['code', code]);

            if (existing) {
                if (this.checkDisabledPromo(existing)) {
                    this.setSearchStatus(index, 'error', 'Insufficient purchase value!');
                } else {
                    this.selectPromoCode(existing, this.promoItems[index]);
                    this.setSearchStatus(index, 'success', 'Selected your promo code!');
                }
                return;
            }

            const response = await this.$asyncPost(this.$routes["search_promo_codes"], {
                id, type, code,
            }, false);

            if (response.status == 'success') {
                var promoCode = response.data;
                this.promoCodeSearchbox[index] = '';
                if (_.find(currentPromoCodes, ['id', promoCode.id])) {
                    // Already has one

                    this.setSearchStatus(index, 'error', 'This promo code has already been added');
                    // Swal.fire({
                    //     title: 'Sorry',
                    //     type: 'error',
                    //     text: 'This promo code has already been added',
                    //     allowOutsideClick: () => !Swal.isLoading()
                    // });
                } else {
                    this.promoItems[index].activePromoCodes.push(promoCode);
                    this.selectPromoCode(promoCode, this.promoItems[index]);
                    this.setSearchStatus(index, 'success', response.message);
                    // Swal.fire({
                    //     title: 'Success',
                    //     type: 'success',
                    //     text: response.message,
                    //     allowOutsideClick: () => !Swal.isLoading()
                    // });
                }
            } else {
                this.setSearchStatus(index, 'error', response.message);

            }
        },
        selectPromoCode: function(promoCode, promoItem) {
            this.selectedPromoCodes.push({ promoCode, promoItem });
        },
        getSummarizedPromoCodes: function() {
            var summarized = {};
            _.each(this.selectedPromoCodes, (item) => {
                if (summarized[item.promoItem.id]) {
                    summarized[item.promoItem.id]['promoIds'].push(item.promoCode.id);
                } else {
                    summarized[item.promoItem.id] = {
                        'type': item.promoItem.type,
                        'quantity': item.promoItem.qty,
                        'promoIds': [item.promoCode.id]
                    }
                }
            });
            return summarized;
        },
        applyPromoCodes: async function() {
            const response = await this.$asyncPost(this.$routes["apply_promo_codes"], {
                promo: this.getSummarizedPromoCodes()
            });

            this.selectedPromoCodesApplied = [...this.selectedPromoCodes];

            if (response && response.data) {
                this.discounts_bpoint = response.data.discounts_bpoint;
                this.discounts_price = response.data.discounts_price;
                this.rewards = response.data.rewards;
                this.discounts_bpoint_formatted = response.data.discounts_bpoint_formatted;
                this.discounts_price_formatted = response.data.discounts_price_formatted;
                this.rewards_formatted = response.data.rewards_formatted;
                this.discounted_point_formatted = response.data.discounted_bpoint_formatted;
                this.discounted_pay_formatted = response.data.discounted_price_formatted;
                this.overflow_bpoint = response.data.overflow_bpoint;
                this.overflow_price = response.data.overflow_price;
            }

            $('#promo_code_modal').modal('hide');
            $('#totalBpointRequire').val(this.discounted_point_formatted.replace(",",""));
            updatePrice(this.discounted_point_formatted);
        },
        cardPin: function () {
//            Swal.fire({
//                title: "Please key in your PIN to confirm redemption",
//                input: 'text',
//                showCancelButton: true,
//                inputPlaceholder: "Card Pin",
//                showLoaderOnConfirm: true,
//
//                allowOutsideClick: () => !Swal.isLoading()
//            }).then((input) => {
//                if (input.value) {
//                    // this.point = this.$refs.pointInput.value;
//                    // this.pay = this.$refs.payInput.value;
//                    this.pin = input.value;
//                    this.cardNo = this.$refs.paymentCardNoInput.value;
//
//                    if(this.pay > 0){   //using point & creditcard
//                        var result = this.$asyncPost(this.$routes["payment_signature"], {
//                            pay: this.pay,
//                            point: this.point,
//                            pin: this.pin
//                        }).then(function (result) {
//                            if (result.status == "success") {
//                                pay(result.data);
//                            } else {
//                              Swal.fire({
//                                  type: "error",
//                                  title: "Oops!",
//                                  text: result.message,
//                              })
//                            }
//                        });
//
//                    }else{  //using point only
//console.log(2)
//                        var result = this.$asyncPost(this.url, {
//                            point: this.point,
//                            pay: this.pay,
//                            pin: this.pin,
//                            cardNo:this.cardNo
//                        }).then(function (result) {
//console.log(result)
//                            if (result.status == "success") {
//                                Swal.fire({
//                                    type: "success",
//                                    title: "Congratulations",
//                                    html: result.message,
//                                    confirmButtonText: 'View Voucher',
//                                }).then((e) =>  {
//                                    if(e.dismiss){
//                                        window.location.href = '/redeem_bpoints';
//                                        //this.$redirect(this.$routes["redeem_bpoints"]);
//                                    }else{
//window.location.href = '/member/my_vouchers';
//                                        //this.$redirect(this.$routes["my_vouchers"]);
//                                    }
//                                  });
//                            } else {
//                              Swal.fire({
//                                  type: "error",
//                                  title: "Oops!",
//                                  text: result.message,
//                              })
//                            }
//                        });
//
//
//                    }
//                }
//            })
    this.pay=this.$refs.payInput.value;
    this.payment_method=this.$refs.paymentMethod.value;
    this.paymentPoint = this.$refs.paymentPointInput.value;
    this.point = this.$refs.pointInput.value;
    console.log('point: '+this.point);
    
            if(this.$refs.paymentCardNoInput.value == ''){
                  Swal.fire({
                                  type: "error",
                                  title: "You have not selected your BCard",
                              });
                return;
            }

            console.log('pay: '+this.pay);
            console.log(this.discounted_point_formatted.replace(",",""))
            if(this.payment_method == 'payWithBPoint' && this.point - this.discounted_point_formatted.replace(",","") < 0){
                  Swal.fire({
                                  type: "error",
                                  title: "Sorry, insufficient BPoints",
                                  text:"You may select alternate BCard (if any)."
                              });
                return;
            }

            Swal.fire({

                title: "Please key in your 6-Digit BCard PIN to proceed",
                html: `<div class="input-group mb-3 cardpin">
                  <input id="password-input-custom" type="password" class="form-control" >
                  <div class="input-group-append" id="visible-btn">
                    <span class="input-group-text custom-append"><i class="far fa-eye-slash" id="visible-icon"></i></span>
                  </div>
                </div>`,
                showCancelButton: true,
                inputPlaceholder: "Card Pin",
                showLoaderOnConfirm: true,
                onBeforeOpen: () => {
                  let input = $('#password-input-custom');
                  let icon = $('#visible-icon');

                  $( "#visible-btn" ).click(function() {
                      if(input.is(":password")){
                          input.prop('type', 'text')
                          icon.attr('class', 'fas fa-eye')
                          //icon.attr('class', 'fas fa-eye-slash')
                      }
                      else {
                          input.prop('type', 'password')
                          icon.attr('class', 'fas fa-eye-slash')
                          //icon.attr('class', 'far fa-eye')
                      }
                  });
                },
                onClose: () => {
                 //   $('#redeemModal').modal('hide');
                },
                preConfirm: () => {
                    this.pin = $('#password-input-custom').val();
                    this.cardNo = this.$refs.paymentCardNoInput.value;
                    if(this.cardNo ==''){
                        throw new Error('You have not selected your BCard');
                    }

                     if(this.pay > 0){
                        return this.$asyncPost(this.$routes["payment_signature"], {
                               promo: this.getSummarizedPromoCodes(),
                               pay: this.pay,
                               point: this.paymentPoint,
                               pin: this.pin,
                               cardNo:this.cardNo,
                               payment_method: this.payment_method,
                           })
                       .then(response => {

                         if (response.status == 'error' || response.status =='fail') {
                           throw new Error(response.message)
                         }
                         
                         return response;
                       })
                       .catch(error => {
                         Swal.showValidationMessage(
                           ` ${error}`
                         )
                       })
                   }else{
                        return this.$asyncPost(this.url, {
                               promo: this.getSummarizedPromoCodes(),
                               pay: this.pay,
                               point: this.paymentPoint,
                               pin: this.pin,
                               cardNo:this.cardNo
                           })
                       .then(response => {
                         if (response.status == 'error') {
                           throw new Error(response.message)
                         }
                         return response
                       })
                       .catch(error => {
                         Swal.showValidationMessage(
                           ` ${error}`
                         )
                       })
                   }


                },
                allowOutsideClick: () => !Swal.isLoading()
              }).then((result) => {
                  
                console.log(result);
                if (result.value) {

                var result=result.value;
                console.log(result);
                
                
                if(this.pay > 0){
                     pay(result.data);
                     return;
                }
                if (result.status == "success") {
                        Swal.fire({
                            type: "success",
                            title: "Congratulations",
                            text:'Your redeemed voucher(s) are stored in your profile page. Click the button to view your voucher',
                            html: result.message,
                            confirmButtonText: 'View Voucher',
                        }).then((e) =>  {
                            if(e.dismiss){
                                window.location.href = '/redeem_bpoints';
                                //this.$redirect(this.$routes["redeem_bpoints"]);
                            }else{
                            window.location.href = '/member/my_vouchers';
                                //this.$redirect(this.$routes["my_vouchers"]);
                            }
                          });
                    } else {
                      Swal.fire({
                          type: "error",
                          title: "Oops!",
                          text: result.message,
                      })
                    }


                }
              })
        }
    }
};
</script>
